import { render, staticRenderFns } from "./GetADemoZh.vue?vue&type=template&id=73f4114a"
import script from "./GetADemoZh.vue?vue&type=script&lang=js"
export * from "./GetADemoZh.vue?vue&type=script&lang=js"
import style0 from "./GetADemoZh.vue?vue&type=style&index=0&id=73f4114a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports